/**
 * Timeline status values
 */
export const TIMELINE_STATUS = {
  INCOMPLETE: 'incomplete',
  IN_PROGRESS: 'in-progress',
  COMPLETE: 'complete',
} as const;

/**
 * Timeline status type
 */
export type TimelineStatus = (typeof TIMELINE_STATUS)[keyof typeof TIMELINE_STATUS];

/**
 * Step identifiers for the patient order status timeline (`orderStatusTimeline` + `Timeline` UI).
 */
export type TimelineStepId = 'ordered' | 'sample-received' | 'lab' | 'reported' | 'clinician-review' | 'completed';

/**
 * One column in the timeline UI (`group` in `TimelineLabel` / `TimelineCluster`).
 * `secondaryText` is supplemental line copy only (e.g. “In progress”, “1 of 2”). Dates use `dateText`.
 */
export interface TimelineGroup {
  id: TimelineStepId;
  label: string;
  secondaryText?: string;
  tooltipText?: string;
  status?: TimelineStatus;
  /** Formatted date shown under the dot on desktop; under the label on mobile */
  dateText?: string;
}

/**
 * Input step shape for `<Timeline steps={...} />` and builders such as `orderStatusTimeline`.
 * Same fields as `TimelineGroup`.
 */
export type TimelineStep = TimelineGroup;
